<template>
    <div>
        <!-- Header -->
        <div class="header py-7 py-lg-8 pt-lg-9" :class="themeClass">
            <div class="container">
                <div class="header-body text-center mb-5">
                    <div class="row justify-content-center">
                        <div class="col-xl-5 col-lg-6 col-md-8 px-5">
                            <h1 class="text-white">{{ $t('auth.forgot-password') }}</h1>
                            <p class="text-lead text-white">{{ $t('auth.forgot-password-description') }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="separator separator-bottom separator-skew zindex-100">
                <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
                    xmlns="http://www.w3.org/2000/svg">
                    <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
                </svg>
            </div>
        </div>

        <!-- Page content -->
        <div class="container mt--8 pb-5">
            <div class="row justify-content-center">
                <div class="col-lg-5 col-md-7">
                    <forgot-password-card></forgot-password-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ForgotPasswordCard from './components/ForgotPasswordCard'

    export default {

        components: {
            ForgotPasswordCard
        },
        
        computed: {
            themeClass() {
                let color = window.astralTheme == 'blue' ? 'info' : window.astralTheme
                return 'bg-gradient-' + color
            }
        }
    }
</script>
